export type CategoryContext = 'browse' | 'add-item';

export interface CategoryLevelRouteData {
  depth: number;
  context: CategoryContext;
}

export const FILTER_CHAIN = [
  'subcategory',
  'subSubcategory',
  'subSubSubcategory',
  'subSubSubSubcategory',
  'subSubSubSubSubcategory',
  'subSubSubSubSubSubcategory',
  'subSubSubSubSubSubSubcategory',
  'subSubSubSubSubSubSubSubcategory',
] as const;

export type FilterChainKey = typeof FILTER_CHAIN[number];

export interface BrowseMotorsLevelConfig {
  depth: number;
  titleFilterKey: FilterChainKey;
  breadcrumbAlias: string;
  itemsApiPath: string;
  newCategoryField: string;
}

export interface CategoryLevelConfig {
  depth: number;
  context: CategoryContext;
  titleFilterKey: FilterChainKey;
  breadcrumbAlias: string;
  itemsApiPath: string;
  newCategoryField: string;
}

function getItemsApiPath(depth: number, context: CategoryContext): string {
  if (context === 'add-item') {
    // /add-listing/<category> lists subcategories (one level below browse).
    return `/items/${'sub'.repeat(depth - 1)}categories`;
  }
  return `/items/${'sub'.repeat(depth)}categories`;
}

export function getCategoryLevelConfig(depth: number, context: CategoryContext): CategoryLevelConfig {
  if (depth < 2 || depth > 8) {
    throw new Error(`Unsupported category level depth: ${depth}`);
  }

  return {
    depth,
    context,
    titleFilterKey: FILTER_CHAIN[depth - 2],
    breadcrumbAlias: `@${'sub'.repeat(depth)}paramotor`,
    itemsApiPath: getItemsApiPath(depth, context),
    newCategoryField: `new${'Sub'.repeat(depth)}category`,
  };
}

/** @deprecated use getCategoryLevelConfig(depth, 'browse') */
export function getBrowseMotorsConfig(depth: number): BrowseMotorsLevelConfig {
  if (depth < 2 || depth > 8) {
    throw new Error(`Unsupported browse motors depth: ${depth}`);
  }

  return {
    depth,
    titleFilterKey: FILTER_CHAIN[depth - 2],
    breadcrumbAlias: `@${'sub'.repeat(depth)}paramotor`,
    itemsApiPath: `/items/${'sub'.repeat(depth)}categories`,
    newCategoryField: `new${'Sub'.repeat(depth)}category`,
  };
}

export function getNewCategoryFieldName(depth: number): string {
  return `new${'Sub'.repeat(depth)}category`;
}

export function getSaveCategoryFieldName(subCount: number): string {
  return `new${'Sub'.repeat(subCount)}category`;
}

export function getBreadcrumbAlias(depth: number): string {
  return `${'sub'.repeat(depth)}paramotor`;
}
